import React, {useEffect, useMemo, useState} from 'react';
import {Button, Card, Checkbox, Divider, Form, Input, message, PageHeader, Radio, Select, Space, Table, Tag} from 'antd';
import {ExamApi, ExamDto, ExamSubmissionDto, UserApi} from '../../../scaffold';
import {useList, useMount} from 'react-use';
import {useOpenApiFpRequest} from '../../../Http/useOpenApiRequest';
import CommonApiErrorHandler from '../../../utils/HttpInstance';
import {useParams} from 'react-router-dom';
import {useTabLayout} from '../../../TabLayout/TabLayoutProvider';
import QuestionDisplay from '../../../components/Question/QuestionDisplay';
import SearchAndRefresh from '../../../components/Shared/SearchAndRefresh';
import {useBoolean, useInput} from 'react-hanger';
import PaperKeywordFilter from '../../../utils/keywordFiliter/Paper';
import ExamSubmissionKeywordFilter from '../../../utils/keywordFiliter/ExamSubmission';
import ExamGroupSubmission from '../../../components/Exam/GroupSubmission';
import useAuth from '../../../utils/AuthContext';

export default function AppExamUserPage() {
  const searchState = useOpenApiFpRequest(ExamApi, ExamApi.prototype.examSearchSubmissionGet);
  const findUser = useOpenApiFpRequest(UserApi, UserApi.prototype.userFindGet);
  const tabLayout = useTabLayout();
  const auth = useAuth();
  useMount(() => {
    findUser
      .request({id: auth.currentUser?.id || 0})
      .then(res => {
        tabLayout.setTitle(`活动记录: ${res?.name}`);
        searchState.request({userId: auth.currentUser?.id || 0, pi: 1, ps: 9999}).catch();
      })
      .catch();
  });

  return (
    <div>
      <PageHeader title={`活动记录: ${findUser.data?.name}`} style={{background: 'white'}} />
      <div className={'p-20'} style={{overflowY: 'auto'}}>
        <Card className={'m-b-15'} loading={searchState.loading}>
          <Table size={'small'} className={'m-t-10'} bordered dataSource={searchState.data?.list || []} rowKey={'id'} loading={searchState.loading}>
            <Table.Column title={'编号'} dataIndex={'id'} width={100} />
            <Table.Column title={'活动名称'} dataIndex={['exam', 'name']} />
            <Table.Column<ExamDto>
              title={'操作'}
              width={300}
              render={(_, item) => (
                <Space>
                  <a onClick={() => tabLayout.goTo('/app/exam/result/' + item.id)}>查看闯关记录</a>
                </Space>
              )}
            />
          </Table>
        </Card>
      </div>
    </div>
  );
}
